import client from "./client";

export const platformStats = async () => (await client.get("/platform/stats")).data;
export const listCompanies = async () => (await client.get("/platform/companies")).data;
export const createCompany = async (body) => (await client.post("/platform/companies", body)).data;
export const updateCompany = async (id, body) => (await client.put(`/platform/companies/${id}`, body)).data;
export const listSignupRequests = async (status = "pending") =>
  (await client.get("/signup-requests", { params: { status } })).data;
export const deleteCompany = (id, code) =>
  client.delete(`/platform/companies/${id}`, { params: { code } });
export const requestArchiveCode = async (id) =>
  (await client.post(`/platform/companies/${id}/archive-code`)).data;
export const resendActivation = async (id) =>
  (await client.post(`/platform/companies/${id}/resend-activation`)).data;
export const companyReceipts = async (id) =>
  (await client.get(`/platform/companies/${id}/receipts`)).data;
export const paymentsHealth = async () => (await client.get("/platform/payments/health")).data;
export const delinquentCompanies = async () => (await client.get("/platform/payments/delinquent")).data;
export const registerPaymentDomain = async (domain) =>
  (await client.post("/platform/payments/domains", { domain })).data;
export const platformLogs = async () => (await client.get("/platform/logs")).data;
export const faceCostReport = async (month) =>
  (await client.get("/platform/face-cost", { params: month ? { month } : {} })).data;
export const opsCosts = async (month) =>
  (await client.get("/platform/ops-costs", { params: month ? { month } : {} })).data;
export const saveOpsThreshold = async (provider, threshold) =>
  (await client.put("/platform/ops-costs/threshold", { provider, threshold })).data;
export const opsBackfill = async () => (await client.post("/platform/ops-costs/backfill")).data;
export const opsTrends = async (months = 12) =>
  (await client.get("/platform/ops-costs/trends", { params: { months } })).data;
export const systemCode = async () => (await client.get("/platform/system/code")).data;
export const systemPerformance = async (hours = 24) =>
  (await client.get("/platform/system/performance", { params: { hours } })).data;
export const systemStorage = async () => (await client.get("/platform/system/storage")).data;
export const systemGeo = async (days = 30) =>
  (await client.get("/platform/system/geo", { params: { days } })).data;
export const systemIntegrations = async () => (await client.get("/platform/system/integrations")).data;
export const systemTrends = async (days = 7) =>
  (await client.get("/platform/system/trends", { params: { days } })).data;
export const systemSessions = async () => (await client.get("/platform/system/sessions")).data;
export const systemCrons = async () => (await client.get("/platform/system/crons")).data;
export const systemNotifyHealth = async () => (await client.get("/platform/system/notify-health")).data;
export const systemCompanies = async (days = 30) =>
  (await client.get("/platform/system/companies", { params: { days } })).data;
export const systemAlerts = async () => (await client.get("/platform/system/alerts")).data;
export const revokeSession = async (userId) =>
  (await client.post(`/platform/system/sessions/${userId}/revoke`)).data;
export const systemRevocations = async () => (await client.get("/platform/system/revocations")).data;
export const alertConfig = async () => (await client.get("/platform/system/alert-config")).data;
export const systemHealthFlags = async () => (await client.get("/platform/system/health-flags")).data;
export const systemCapacity = async () => (await client.get("/platform/system/capacity")).data;
export const featureAdoption = async () => (await client.get("/platform/features/adoption")).data;
export const featureRequests = async () => (await client.get("/platform/features/requests")).data;
export const companyFeatures = async (id) => (await client.get(`/platform/companies/${id}/features`)).data;
export const setCompanyFeature = async (id, feature, enabled) =>
  (await client.patch(`/platform/companies/${id}/features`, { feature, enabled })).data;
export const saveAlertConfig = async (body) => (await client.put("/platform/system/alert-config", body)).data;
export const emailLookup = async (email) =>
  (await client.get("/platform/email-lookup", { params: { email } })).data;

export const broadcastOptions = async () => (await client.get("/platform/notify/options")).data;
export const broadcastGeo = async () => (await client.get("/platform/notify/geo")).data;
export const broadcastPreview = async (filter) => (await client.post("/platform/notify/preview", filter)).data;
export const broadcastSend = async (body) => (await client.post("/platform/notify/send", body)).data;
export const broadcastHistory = async () => (await client.get("/platform/notify/history")).data;
export const broadcastResend = async (id) => (await client.post(`/platform/notify/resend/${id}`)).data;

export const avatarCompanies = async (q = "") => (await client.get("/platform/avatars/companies", { params: { q } })).data;
export const avatarEmployees = async (id, q = "") =>
  (await client.get(`/platform/avatars/companies/${id}/employees`, { params: { q } })).data;
export const resetAvatars = async (body) => (await client.post("/platform/avatars/reset", body)).data;
export const avatarGlobalEstimate = async () => (await client.get("/platform/avatars/global-estimate")).data;
export const avatarResetAll = async () => (await client.post("/platform/avatars/reset-all")).data;
